import RegistrationTemplate from "../../templates/RegistrationTemplate/RegistrationTemplate";

const Registration = () => {
  // useDocumentTitleLoading(); // TODO: Fix it later, right now "loading" doesn't disappear after step is loaded

  return <RegistrationTemplate />
};

export default Registration;
